module.exports = __webpack_public_path__ + "img/雷达图.f9acbbc7.png";